// extracted by mini-css-extract-plugin
module.exports = {"appFooter":"AppFooter_appFooter__3cBan"};